<div
  class="patient_history_list_table"
  [ngClass]="!isMainReport ? 'save-and-submit-study-worklist' : ''"
>
  <p-table
    #dt1
    [value]="patientHistoryData"
    dataKey="PatienthistoryId"
    [(selection)]="selectedPatients"
    [rows]="10"
    [rowHover]="true"
    styleClass="p-datatable-gridlines"
    [paginator]="true"
    responsiveLayout="scroll"
  >
    <ng-template pTemplate="header">
      <tr>
        <!-- <th style="width: 50px; text-align: center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->
        <th pSortableColumn="AccessionNo">
          Accession#<p-sortIcon field="AccessionNo"></p-sortIcon>
        </th>
        <th pSortableColumn="HN">
          HN#<p-sortIcon field="HN"></p-sortIcon>
        </th>
        <th pSortableColumn="PatientName">
          Patient Name<p-sortIcon field="PatientName"></p-sortIcon>
        </th>
        <th pSortableColumn="ExamName">
          Exam Name<p-sortIcon field="ExamName"></p-sortIcon>
        </th>

        <th pSortableColumn="ImageCount">
          Image# <p-sortIcon field="ImageCount"></p-sortIcon>
        </th>
        <th pSortableColumn="PacsHistorySendStatus">
          PACS Status <p-sortIcon field="PacsHistorySendStatus"></p-sortIcon>
        </th>
        <th pSortableColumn="CreatedOn">
          Create On <p-sortIcon field="CreatedOn"></p-sortIcon>
        </th>
        <th pSortableColumn="CreatedByName">
          Created By <p-sortIcon field="CreatedByName"></p-sortIcon>
        </th>
        <!-- <th pSortableColumn="UpdateBy">
          Upadate By <p-sortIcon field="UpdateBy"></p-sortIcon>
        </th>
        <th pSortableColumn="LastModifiedOn">
          Upadate On <p-sortIcon field="LastModifiedOn"></p-sortIcon>
        </th> -->
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-patientHistoryData>
      <tr [pSelectableRow]="patientHistoryData">
        <!-- <td style="text-align: center">
          <p-tableCheckbox [value]="patientHistoryData"></p-tableCheckbox>
        </td> -->
        <td>
          {{ studyWorklistData.AccessionNo }}
        </td>
        <td>
          {{ studyWorklistData.Hn }}
        </td>
        <td>
          {{ studyWorklistData.PatientName }}
        </td>
        <td>
          {{ studyWorklistData.ExamName }}
        </td>
        <td>
          {{ patientHistoryData.ImageCount }}
        </td>
        <td>
          {{ patientHistoryData.PacsHistorySendStatus }}
        </td>
        <td>
          {{ patientHistoryData.CreatedOn | date : "dd-MM-yyyy hh:mm a" }}
        </td>
        <td>
          {{ patientHistoryData.CreatedByName }}
        </td>
        <!-- <td>
          {{ patientHistoryData.UpdateBy }}
        </td>
        <td>
          {{ patientHistoryData.LastModifiedOn | date : "dd-MM-yyyy hh:mm a" }}
        </td> -->
        <td [style.width.px]="110">
          <div class="flex justify-content-between align-items-center">

            <button
            type="button"
              (click)="resendHistoryToPACS(patientHistoryData)"
              icon="fa fa-paper-plane fa-large"
              class="p-button-rounded mr-1 mb-1"
              title="Resend to PACS"
              pButton
            ></button>

          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center">No data found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="4" class="text-center">
          Loading uploaded document data. Please wait.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="AI Finding"
  [(visible)]="displayResultText"
  appendTo="body"
  [modal]="true"
>
  <div class="grid">
    <div class="col-12">
      <p-editor
        readonly="true"
        [(ngModel)]="examResult"
        [style]="{ height: '320px' }"
      >
        <p-header> </p-header>
      </p-editor>
      <br />
      <br />
      <strong>AI DISCLAIMER:</strong> This is an AI generated Finding.
      <br />
      <br />
      <strong>DISCLAIMER: </strong>{{ siteDetail?.RepFooter1 }}
    </div>
  </div>
</p-dialog>

<!-- Study Swap Confirmation Dialog START -->
<p-confirmDialog
  header="Confirmation"
  key="changeStudyStatus"
  icon="pi pi-exclamation-triangle"
  message="Are you sure you want to proceed?"
  [style]="{ width: '350px' }"
  acceptButtonStyleClass="p-button-text"
  rejectButtonStyleClass="p-button-text"
></p-confirmDialog>
<!-- Study Swap Confirmation Dialog END -->
